import moment from 'moment'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Loader from '../../common/loader/Loader'
import { ReactComponent as MailIcon } from '../../../assets/images/common/icons/mail-icon.svg'
import classes from './InvitedTable.module.scss'
import React from 'react'


const InvitedTable = ({ students, onResendInvite }) => {
  const { t } = useTranslation()

  if (!students) {
    return (
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <Loader>{t('members.loading.invitations')}</Loader>
      </div>
    )
  }

  return (
    <div id='studentsTable' className={classes.table}>
      <div className={classes.gridTable} id='tableContent'>
        <div className={classNames(classes.col, classes.header, classes.firstColumn, classes.topLeft)}>
          <span className='font-weight-bold'>{t('members.studentsCountHeading', { count: students?.length || 0 })}</span>
        </div>
        <div className={classNames(classes.col, classes.header)}>
          {t('members.invitedTable.columns.invitedOn')}
        </div>
        <div className={classNames(classes.col, classes.header)}>
          {t('common.field.email')}
        </div>
        <div className={classNames(classes.col, classes.header)}>
          {t('members.invitedTable.columns.invitedBy')}
        </div>
        <div className={classNames(classes.col, classes.header)}>
          {t('members.invitedTable.columns.resendInvite')}
        </div>

        {students.map(student => (
          <div key={student.id} className={classNames(classes.row)}>
            <div
              className={classNames(classes.col, classes.firstColumn, classes.studentInfo)}
              title={`${student.firstName} ${student.lastName}`}
            >
              <p className='font-weight-bold m-0'>{student.firstName} {student.lastName}</p>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <span className='font-weight-bold'>{student.createdAt ? moment(student.createdAt).format('DD/MM/YYYY') : '-'}</span>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <span>{student.email || ''}</span>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <span className='font-weight-bold'>
                {student.inviter ? `${student.inviter.firstName} ${student.inviter.lastName}` : '-'}
              </span>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <button className={classes.resendInviteButton} onClick={() => onResendInvite(student.id)}>
                <MailIcon className={classes.contactIcon} />
                {t('members.invitedTable.columns.resendInvite')}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

InvitedTable.propTypes = {
  students: PropTypes.array,
  isLoading: PropTypes.bool,
  onResendInvite: PropTypes.func,
}

export default InvitedTable
